import { ReactComponent as JUG } from "../../customIcons/Jug.svg";
import { ReactComponent as D30 } from "../../customIcons/Drum30.svg";
import { ReactComponent as D55 } from "../../customIcons/Drum55.svg";
import { ReactComponent as TOTE } from "../../customIcons/Tote.svg";
import { ReactComponent as PFC } from "../../customIcons/PFC.svg";
import { ReactComponent as B50 } from "../../customIcons/Bag50.svg";
import { ReactComponent as B40 } from "../../customIcons/Bag40.svg";
import { ReactComponent as B30 } from "../../customIcons/Bag30.svg";
import { ReactComponent as B25 } from "../../customIcons/Bag25.svg";
import { ReactComponent as TR } from "../../customIcons/ToteRefill.svg";
import { ReactComponent as GAL } from "../../customIcons/GAL.svg";
import { ReactComponent as LBS } from "../../customIcons/LBS.svg";
import { ReactComponent as PAIL } from "../../customIcons/Pail.svg";
import { ReactComponent as GALJUG } from "../../customIcons/GalJug.svg";


import {Button, Input, Select} from "@headlessui/react";
import React, {useEffect, useState} from "react";
import {XMarkIcon} from "@heroicons/react/16/solid";
import {useDarkMode} from "../../contexts/darkModeContext";
import {
    BanknotesIcon,
    LockClosedIcon,
    PencilIcon,
} from "@heroicons/react/24/outline";
import {UMMapping} from "../GLOBAL/GlobalFunctions";

const DeveloperProductInput = ({ accountLevel, index, blank, UniqueKey, onRemove, onAdd, product, priceType, discount, contractPrices, region, lineItem, tankLocations }) => {
    
    const [id] = useState(lineItem?.id || product?.id);
    const [price, setPrice] = useState( lineItem?.price || 0);
    const [orginalPrice, setOrginalPrice] = useState(0);
    const [quantity, setQuantity] = useState(lineItem?.quantity || '1');
    const [productCode, setProductCode] = useState( lineItem?.productCode || "");
    const [total, setTotal] = useState((price * quantity).toFixed(2));
    const [actualTotal, setActualTotal] = useState(0);
    const [selectedVolume, setSelectedVolume] = useState(lineItem?.selectedVolume || product?.prices[0].um); // Set to the first `um` in prices or an empty string if prices is empty
    const [name, setName] = useState(lineItem?.name || "");
    const [uniqueKey] = useState(lineItem?.uniqueKey || UniqueKey || "");
    
    const [manualDiscount, setManualDiscount] = useState(false);
    
    const [blankItem] = useState(lineItem?.blankItem || blank);
    
    const [edit, setEdit] = useState(lineItem?.edit || false);
    
    // const [lock] = useState(lineItem?.selectedVolume || product?.lock || false);
    const [lock] = useState(
        !!lineItem?.lock || !!product?.lock || false
    );
    
    const [warehouse] = useState("MAIN");
    const [disabled, setDisabled] = useState(false);
    const [discountAmount, setDiscountAmount] = useState(lineItem?.discountAmount || discount);
    const [unitLabel, setUnitLabel] = useState("Quant");
    const [contract, setContract] = useState(false);
    
    

    const { darkMode } = useDarkMode();

    
    const [isDiscountApplied, setDiscountApplied] = useState(false);
    const [isDiscountDisplayed, setDiscountDisplayed] = useState(false);
    
    // Discount
    
    
    useEffect(() => {
        const baseTotal = price * quantity;
        const formattedBaseTotal = baseTotal.toFixed(2);
    
        let calculatedDiscount = 0;
        const isAG = priceType === "AG";
        const isGAL = selectedVolume === 'GAL' || selectedVolume === 'TON';
        const shouldLockDiscount = lock || contract;
    
        // Auto-calculate only if manualDiscount is false
        if (lineItem?.discountAmount > 0) {
            calculatedDiscount = lineItem.discountAmount;
            console.log('✅ Line item discount applied:', calculatedDiscount);
        } else if (!shouldLockDiscount && !manualDiscount) {
            if ((isAG && isGAL) || (!isAG && !isGAL)) {
                calculatedDiscount = discount;
                console.log('✅ Standard discount applied:', calculatedDiscount);
            } else {
                console.log('❌ Discount not applied due to type/volume rules');
            }
        } else {
            console.log('❌ Discount blocked by lock/contract');
        }
    
        // Determine final discount amount
        const finalDiscount = manualDiscount ? discountAmount : calculatedDiscount;
        const discountedTotal = (baseTotal * (1 - (finalDiscount / 100))).toFixed(2);
    
        setDiscountApplied(finalDiscount > 0);
        setDiscountDisplayed(finalDiscount > 0 && !lock);
    
        if (actualTotal !== formattedBaseTotal) setActualTotal(formattedBaseTotal);
        if (total !== discountedTotal) setTotal(discountedTotal);
    
        // Only update discountAmount if NOT manually set
        if (!manualDiscount && discountAmount !== calculatedDiscount) {
            setDiscountAmount(calculatedDiscount);
        }
    
        console.log('✅ Discount recalculated | Base:', formattedBaseTotal, '| Discount:', finalDiscount, '| Total:', discountedTotal);
    // eslint-disable-next-line
    }, [
        price,
        quantity,
        selectedVolume,
        discount,
        lineItem?.discountAmount,
        lock,
        contract,
        priceType,
        discountAmount,
        manualDiscount,
    ]);
    
    
    
    useEffect(() => {
        setManualDiscount(false);
    }, [priceType, selectedVolume]);

  
    const getPriceBasedOnSelection = (prices, priceType, quantity) => {
        // Ensure prices is an array
        if (!Array.isArray(prices)) {
            console.error("Prices must be an array");
            return 0;
        }

        // Convert priceType to lowercase to handle case insensitivity
        const normalizedPriceType = priceType.toLowerCase();

        // Find the price object where 'um' matches the specified quantity
        const priceObject = prices.find((price) => price.um === quantity);

        if (priceObject && priceObject[normalizedPriceType]) {
            return priceObject[normalizedPriceType];
        }

        return 0;
    };


    useEffect(() => {
        setIsLoaded(true);
        console.log('loaded');
    }, []);

    const [isLoaded, setIsLoaded] = useState(false); // State to track when the component is loaded
    const [isRemoving, setIsRemoving] = useState(false); // Track whether the item is being removed

    // Handle the remove action with animation
    const handleRemove = () => {
        console.log("Removing Key:", uniqueKey);
        setIsRemoving(true);
        setTimeout(() => {
            onRemove(uniqueKey);
            setIsRemoving(false); // clean up if needed
        }, 500);
    };

    const [priceLimited, setPriceLimited] = useState(false);
    
    const [SelectedComponent, setSelectedComponent] = useState(null); // This will store the component itself
    const sharedClassName = `size-8 ${disabled ? 'text-red-600' : ''} ${contract ? 'text-yellow-600' : ''} ${isDiscountDisplayed ? 'text-blue-600' : ''}`; // You can also move this to Tailwind config if reused widely
    
    
    useEffect(() => {
        if (!product || !priceType || !selectedVolume) return;
        
        const prices = product.prices || [];
        const priceObject = prices.find((price) => price.um === selectedVolume);
        const newPrice = getPriceBasedOnSelection(prices, priceType, selectedVolume);
    
        if (priceObject?.code) {
            setProductCode(priceObject.code);
            console.log("Selected Price Code:", priceObject.code);
        }
    
        const contractPriceEntry = contractPrices.find((contract) => {
            const contractCode = String(contract.productCode).trim().toUpperCase();
            const priceCode = String(productCode).trim().toUpperCase();
            const volumeMatch = String(contract.selectedVolume) === String(selectedVolume);
            return contractCode === priceCode && volumeMatch;
        });
    
        if (edit) {
            const linePrice = lineItem?.price || 0;
            setPrice(linePrice);
            console.log("Price set to line item price due to edit mode:", linePrice);
        } else if (contractPriceEntry) {
            if (contractPriceEntry.percent) {
                setDiscountAmount(contractPriceEntry.newValue);
                setManualDiscount(true); // set manual since it's a user-level contract %
                console.log("Discount applied from contract:", contractPriceEntry.newValue);
            } else {
                const contractPrice = contractPriceEntry.newValue || 0;
                setPrice(contractPrice);
                setContract(true);
                setPriceLimited(false);
                setDiscountAmount(0);
                setManualDiscount(false); // auto pricing
                console.log("Contract price applied:", contractPrice);
            }
        } else {
            const fallbackPrice = newPrice || 0;
            setPrice(fallbackPrice);
            setOrginalPrice(fallbackPrice);
            setContract(false);
            setPriceLimited(false);
            setDiscountAmount(0);
            setManualDiscount(false);
            console.log("Standard price applied:", fallbackPrice);
        }
    
        const isDisabled = !contractPriceEntry && (!newPrice || isNaN(newPrice) || newPrice === 0 || newPrice === "0");
        setDisabled(isDisabled);
    
        // handle quantity/unit defaults
        const volumeMap = {
            "2.5": { component: JUG, unit: "#", quantity: lineItem?.quantity || 1 },
            "30": { component: D30, unit: "#", quantity: lineItem?.quantity || 1 },
            "55": { component: D55, unit: "#", quantity: lineItem?.quantity || 1 },
            "275": { component: TOTE, unit: "#", quantity: lineItem?.quantity || 1 },
            "TR": { component: TR, unit: "gal", quantity: lineItem?.quantity || 100 },
            "GAL": { component: GAL, unit: "gal", quantity: lineItem?.quantity || 600 },
            "B50": { component: B50, unit: "#", quantity: lineItem?.quantity || 1 },
            "B40": { component: B40, unit: "#", quantity: lineItem?.quantity || 1 },
            "B30": { component: B30, unit: "#", quantity: lineItem?.quantity || 1 },
            "B25": { component: B25, unit: "#", quantity: lineItem?.quantity || 1 },
            "LB": { component: LBS, unit: "lbs", quantity: lineItem?.quantity || 1 },
            "PAI": { component: PAIL, unit: "#", quantity: lineItem?.quantity || 1 },
            "CS4": { component: GALJUG, unit: "#", quantity: lineItem?.quantity || 1 },
        };
    
        const volumeData = volumeMap[selectedVolume];
    
        if (volumeData) {
            setSelectedComponent(volumeData.component);
            setUnitLabel(volumeData.unit);
            setQuantity(volumeData.quantity);
        } else {
            setSelectedComponent(PFC);
            setUnitLabel("#");
        }
    
        console.log("✅ Price recalculated");
    
    }, [product, priceType, productCode, selectedVolume, contractPrices, edit, lineItem, blankItem]);
    
    
    const handleVolumeChange = (e) => {
        setSelectedVolume(e.target.value);
    };

    const numberWithCommas = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    

    // Automatically pass data back to the parent whenever any key state changes
    useEffect(() => {
        const productData = {
            price,
            name,
            id,
            quantity,
            productCode,
            total,
            actualTotal,
            selectedVolume,
            warehouse,
            discountAmount,
            contract,
            lock,
            edit,
            disabled,
            uniqueKey,
            blankItem,
        };
        onAdd(index, productData); // Automatically pass the product data to the parent
        
        console.log('added');
            // eslint-disable-next-line
    }, [price, name, quantity, productCode, total, selectedVolume, warehouse, actualTotal, discountAmount, discount, index, id, contract, edit, lock, disabled, blankItem]);
    
    
    
    
    return (
        <div className={`w-full font-sans grid grid-cols-1 gap-x-3 border-b-2 ${blankItem ? 'border-cyan-600 border-dotted' : ''} ${darkMode ? 'border-darkBgColor text-white' : 'text-black'} ${isRemoving ? 'transform animate-slideOutLeft' : ''} mb-1.5 p-1 pb-0.5 transition-transform duration-500 ease-in-out ${isLoaded ? '' : 'translate-x-full opacity-0'}`}>

            {/* Header */}
            <div className={`col-span-1 grid grid-cols-6 gap-x-3`}>
                
                {/*PRODUCT NAME*/}
                <div className="col-span-1 flex flex-row items-center">
                    
                    {/*Icon*/}
                    <div className="flex flex-col mt-auto mb-auto w-11 mr-2">
                        
                        <div className={`w-fit mr-auto ml-auto p-1.5 rounded-lg`}>
                            
                            <div className="w-fit mr-auto ml-auto p-1.5 rounded-lg">
                                {SelectedComponent ? (
                                  <SelectedComponent className={sharedClassName} />
                                ) : (
                                  <PFC className={sharedClassName} />
                                )}
                            </div>
                        
                        </div>
                    
                    
                    </div>
                    
                    {/*Name and Product Code*/}
                    <div className="flex flex-col mt-auto mb-auto w-full">
                        {/*Scrollable Name by Hover*/}
                        <div ref={(container) => {
                            if (container) {
                                    const textElement = container.querySelector('.scrollable-text');
                                    if (textElement) {
                                        container.classList.toggle(
                                            'hover-enabled',
                                            textElement.scrollWidth > container.offsetWidth
                                        );
                                    }
                                }
                            }}
                            className={`${blankItem ? 'hidden' : ''} relative overflow-hidden ${disabled ? 'text-red-600' : ''}  text-sm font-medium w-full`}
                        >
                            <div className="scrollable-text inline-block whitespace-nowrap transition-transform duration-1000 ease-linear"
                                style={{
                                    transform: 'translateX(0)',
                                }}
                                onMouseEnter={(e) => {
                                    const container = e.currentTarget.parentElement;
                                    if (container.classList.contains('hover-enabled')) {
                                        e.currentTarget.style.transform = 'translateX(-50%)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateX(0)';
                                }}
                            >
                                {name}
                            </div>
                        </div>
                        <div className={`${blankItem ? 'hidden' : ''} ml-3 text-xxs ${darkMode ? 'text-borderColor' : 'text-borderColor'}`}>{productCode}</div>
                        
                        
                        {/*Name Input*/}
                        <div className={`mb-1 ${blankItem ? '' : 'hidden'} border-b ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border-2 border-red-600 rounded-lg' : ''} relative flex flex-row px-2 h-full items-center justify-center`}>
                            <Input
                                className={`rounded-md bg-transparent text-xs focus:outline-none p-0.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="string"
                                placeholder={`Enter Product Name`}
                                value={name}
                                disabled={!blankItem}
                                onChange={(event) => setName(event.target.value)} // Update priceType on selection change
                                // onChange={} // This will still allow live input, but without validation
                            />
                        </div>
                        
                        {/*Code Input*/}
                        <div className={`${blankItem ? '' : 'hidden'} border-b ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border-2 border-red-600 rounded-lg' : ''} relative flex flex-row px-2 h-full items-center justify-center`}>
                            <Input
                                className={`rounded-md bg-transparent text-xs focus:outline-none p-0.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="string"
                                placeholder={`Enter Product Code`}
                                value={productCode}
                                onChange={(event) => setProductCode(event.target.value)} // Update priceType on selection change
                                // onChange={} // This will still allow live input, but without validation
                            />
                        </div>
                        
                        
                    </div>
                    
                </div>
    
                {/*PRODUCT PRICING/QUANT WH DISC*/}
                <div className="col-span-4 grid grid-cols-8 gap-x-2">
    
                    {/*PRICE*/}
                    <div className={`relative col-span-2 py-2.5`}>
                        <div className={`border-2 ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border-2 border-red-600 rounded-lg' : ''} relative flex flex-row px-2 rounded-lg h-full items-center justify-center`}>
    
                            <BanknotesIcon className={`size-6 mr-2 text-red-600 animate-heartbeat ${disabled ? '' : 'hidden'}`}/>
                            <div className={`text-borderColor text-md`}>$</div>
                            
                            <Input
                                className={`rounded-md bg-transparent text-sm focus:outline-none p-1.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="number"
                                placeholder={(price === 0 || !price) && !disabled ? 'No Book Price' : 'No'}
                                value={price}
                                disabled={true}
                            />
                            
                            <div className={`text-gray-500 font-bold text-xxs`}>{disabled ? 'Request' : 'USD'}</div>
    
                        </div>
                        <div className={`absolute top-1 right-0`}>
                            <div className={`${contract ? 'hidden' : ''} ${lock ? 'hidden' : ''} ${edit ? 'hidden' : ''} flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                              <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`} />
                            </div>
                        </div>
    
                        {contract && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full p-1 bg-yellow-500/30 animate-rubberBand-delay`}>
                                    <div className={`size-2 rounded-full bg-yellow-500`}/>
                                </div>
                            </div>
                        )}
                        
                        {lock && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                    <LockClosedIcon className={`size-4 stroke-2 rounded-full text-slate-500`}/>
                                </div>
                            </div>
                        )}
                        
                        {edit && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                    <PencilIcon className={`size-4 stroke-2 text-blue-500`}/>
                                </div>
                            </div>
                        )}
    
                    </div>
                    
                    {/*QUANTITY*/}
                    <div className={`relative col-span-2 py-2.5`}>
                        <div className={`border-2 ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border-2 border-red-600 rounded-lg' : ''} flex flex-row px-4 rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                            {/*// When quantity changes, trigger the onChange for recalculation*/}
                            <Input
                                className={`rounded-md bg-transparent text-sm focus:outline-none p-1.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="text"
                                placeholder="Quantity"
                                value={quantity}
                                // disabled={disabled}
                                onChange={(e) => setQuantity(e.target.value)}
                            />
    
                            <div className="text-gray-500 font-bold text-xs ml-1">{unitLabel}</div>
    
    
                            {/*// When price changes (in your select or other logic), ensure price updates are sent to parent.*/}
                        </div>
                        <div className={`absolute top-1 right-0`}>
                        <div className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                              <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`} />
                            </div>
                        </div>
                    </div>
    
                    {/*U/M*/}
                    <div className={`relative col-span-2 py-2.5`}>
                        <div className={`border-2 ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border-2 border-red-600 rounded-lg' : ''} flex flex-row rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                            <Select
                                className={`p-1.5 rounded-md bg-transparent text-xs focus:outline-none ${darkMode ? 'text-white' : 'text-black'} w-full`}
                                onChange={handleVolumeChange}
                                value={selectedVolume}
                            >
                                {blankItem
                                    ? Object.entries(UMMapping).map(([um, label]) => (
                                        <option key={um} value={um}>
                                          {label}
                                        </option>
                                      ))
                                    : product?.prices.map((price, index) => {
                                        const label = UMMapping[price.um];
                                        return label ? (
                                          <option key={index} value={price.um}>
                                            {label}
                                          </option>
                                        ) : null;
                                      })}
    
                            </Select>
                        </div>
                        <div className={`absolute top-1 right-0`}>
                            <div className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                              <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`} />
                            </div>
                        </div>
                    </div>
                    
                    {/*Discount*/}
                    <div className={`relative col-span-2 py-2.5 h-full`}>
                        <div className={`border-2 ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border-2 border-red-600 rounded-lg' : ''} px-1 flex flex-row rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                            <div className="text-borderColor text-xs font-bold">%</div>
    
                            <Input
                                className={`rounded-md bg-transparent text-xs focus:outline-none ml-1.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="number"
                                placeholder="DISC"
                                value={discountAmount}
                                disabled={true}
                            />
                        </div>
                        <div className={`absolute top-1 right-0`}>
                            {isDiscountDisplayed && (
                                <div className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-blue-500/30 animate-rubberBand-delay'}`}>
                                    <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-blue-500'}`}/>
                                </div>
                            )}
                        </div>
                        
                        {lock && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                    <LockClosedIcon className={`size-4 stroke-2 rounded-full text-slate-500`}/>
                                </div>
                            </div>
                        )}
                        
                    </div>
                   
                </div>
    
                {/*PRODUCT TOTAL*/}
                <div className="col-span-1 flex flex-row justify-end align-middle items-center">
                
                    <div className="ml-auto w-full flex flex-row justify-end">
                        
                        <div className={`flex flex-row mt-auto w-full mb-auto align-middle justify-end items-center ${disabled ? 'text-red-600' : ''} ${isDiscountDisplayed ? 'text-blue-600' : ''} ${contract ? 'text-yellow-500' : ''}`}>
                            <div className="text-md mr-3 font-light">$</div>
                            
                            <div className={`relative p-1.5`}>
                                
                                <div className={`text-md mr-3 font-bold tracking-wider`}>{numberWithCommas(total)}</div>
                                
                                <div className={`absolute top-1 right-1`}>
                                    <div className={`flex-none rounded-full p-1 ${isDiscountDisplayed ? 'bg-blue-500/30 animate-heartbeat' : ''}`}>
                                        <div className={`size-2 rounded-full ${isDiscountDisplayed ? 'bg-blue-500' : ''}`}/>
                                    </div>
                                </div>
                            
                            
                            </div>
                            <div className="text-borderColor text-sm">USD</div>
                            
                        </div>
                        
                        <Button className="rounded-full h-8 w-8 items-center justify-center align-middle"
                                disabled={!uniqueKey}
                                onClick={handleRemove}>
                            <XMarkIcon className={`h-6 text-borderColor m-auto ${!uniqueKey ? 'text-red-800' : 'hover:text-red-600 hover:animate-pulse hover:scale-110'}`}/>
                        </Button>
                    </div>
                    
                </div>
                
            </div>
            
        </div>
    )
}

export default DeveloperProductInput;
